import React, { useState, useEffect } from 'react'
import MAndARequestForm from '../components/newhome/RequestForm.manda'

const ALLOWED_REFERRER_PATTERN = /^https:\/\/.*\.usabg\.com/

export default function DoIQualifyPage() {
  const [authorized, setAuthorized] = useState(null)

  useEffect(() => {
    const inIframe = window.self !== window.top
    const referrerOk = ALLOWED_REFERRER_PATTERN.test(document.referrer)

    // Must be in iframe AND have valid referrer (if available)
    setAuthorized(inIframe && (referrerOk || document.referrer === ''))
  }, [])

  if (authorized === null) return <div>Loading...</div>

  if (!authorized) return <div>This form is only available through the partner portal.</div>

  return (
    <div id='DoIQualifyPage'>
      <MAndARequestForm />
    </div>
  )
}
